// NOTE: Left some unused messages, for potential future use
const messages = {
  _default: (field) => `${field} ist ungültig.`,
  after: (field, [target]) => `Das Datum muss nach dem ${target} liegen.`,
  before: (field, [target]) => `Das ${field} muss vor dem ${target} liegen.`,
  date_between: (field, [min, max]) => `${field} muss zwischen ${min} und ${max} liegen.`,
  // date_format: (field, [format]) => `${field} muss das Format ${format} haben.`,
  date_format: (field) => 'Kein gültiges Datum (DD.MM.YYYY).',
  decimal: (field, [decimals = '*'] = []) => `${field} muss numerisch sein und darf ${decimals === '*' ? '' : decimals} Dezimalpunkte enthalten.`,
  email: () => 'Geben Sie eine gültige E-Mail-Adresse ein.',
  ext: (field) => `${field} muss eine gültige Datei sein.`,
  image: (field) => `${field} muss eine Grafik sein.`,
  max: (field, [length]) => `${field} darf nicht länger als ${length} Zeichen sein.`,
  mimes: (field) => `${field} muss einen gültigen Dateityp haben.`,
  min: (field, [length]) => `${field} muss mindestens ${length} Zeichen lang sein.`,
  numeric: (field) => `${field} darf nur numerische Zeichen enthalten.`,
  regex: (field) => `Das Format von ${field} ist ungültig.`,
  required: (field) => `${field} ist ein Pflichtfeld.`,
  maxValueFormatted: (field, [max]) => `Der ${field} darf ${max} nicht übersteigen`,
  invalid_credentials: '<strong>Fehler. </strong>Ungültige E-Mail Adresse oder Passwort. Kontaktieren Sie unser <a href="#">Support-Team.</a>',
  invalid_pin: 'invalid pin message',
  invalid_client: 'Es existiert kein Benutzer mit angegebener E-Mail Adresse.',
  passwords: {
    user: 'Für die angegebene E-Mail-Adresse existiert kein Konto.'
  },
  default: 'Ein Problem ist aufgetreten. Bitte versuchen Sie es erneut.',
};

const attributes = {
  'purpose': 'Verpflichtungsgrund',
  'amount': 'Betrag',
  'valid_until': 'Laufzeit',
  'valid_from': 'Laufzeit',
  'currency': 'Währung',
  'product_id': 'Art der Haftung',
  'company_name': 'Firmenname',
  'street': 'Straße',
  'city': 'Ort',
  'zip_code': 'PLZ',
  'office_id': 'Garantieerstellung durch',
  'country': 'Land',
  'template_id': 'Vorlage',
  'accept_terms': 'Geschäftsbedingungen',
  'email': 'E-Mail',
  'password': 'Passwort',
  'repeat_password': 'Passwort wiederholen',
  'notes': 'Notizen',
  'original_letter_address_text': 'Adresse',
  'copy_original_letter_address_text': 'Adresse',
  'username': 'E-Mail-Adresse',
  'pin': 'PIN',
  'country_id': 'Land',
  'comment_text': 'Ablehnungsgrund',
  'first_name': 'Vorname',
  'last_name': 'Nachname',
  'phone': 'Telefon',
  'current_password': 'Aktuelles Passwort'
};

const locale = {
  name: 'de',
  messages,
  attributes
};

export default locale;
